import { render, staticRenderFns } from "./AnnouncementMessage.vue?vue&type=template&id=076bc5c4"
import script from "./AnnouncementMessage.vue?vue&type=script&lang=js"
export * from "./AnnouncementMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports